import { HttpResponseBody, HttpResponseType } from './interfaces';
import { isManifestMime } from '../common/utils/sourceTypeUtils';
import logger from '../log';
const log = logger.getLogger(__filename);

export default async function getResponseForContentType(
  response: Response,
  responseType?: HttpResponseType
): Promise<HttpResponseBody | undefined> {
  const contentType = response.headers.get('content-type');
  log412(response, responseType, contentType);
  if (response.ok) {
    switch (responseType) {
      case 'arraybuffer':
        return await response.arrayBuffer();
      case 'blob':
        return await response.blob();
      case 'json':
        return await response.json();
      case 'text':
        return await response.text();
      default:
        break;
    }
    // These mime types are for manifests.
    if (
      contentType &&
      (isManifestMime(contentType) || contentType.includes('text/plain'))
    ) {
      return await response.text();
    } else if (isJson(contentType)) {
      return await response.json();
    } else {
      // all other things (at the moment) will be sent back as arraybuffers, because that's what we cache
      return await response.arrayBuffer();
    }
  }
  if (isJson(contentType)) {
    return await response.json();
  }

  return undefined;
}

function log412(
  response: Response,
  responseType?: HttpResponseBody,
  contentType?: string | null
): void {
  if (response.status !== 412) {
    return;
  }
  const msg = {
    contentType,
    isJson: isJson(contentType),
    isManifestMime: isManifestMime(contentType ?? ''),
    responseType
  };
  log.warn(msg);
}

function isJson(contentType?: string | null): boolean {
  if (!contentType) {
    return false;
  }
  const type = contentType.replace(/;.*/, '');
  return type.indexOf('json') > -1;
}
